import { Link } from 'react-router-dom';

export function NotFoundPage(): JSX.Element {
  return (
    <div className="mx-auto max-w-lg py-16 text-center">
      <p className="text-sm font-medium text-slate-500">404</p>
      <h1 className="mt-2 text-2xl font-semibold tracking-tight text-slate-900">
        Esta página no existe
      </h1>
      <p className="mt-3 text-sm text-slate-600">
        Comprueba la URL o vuelve al dashboard para continuar.
      </p>
      <Link to="/dashboard" className="btn-primary mt-6 inline-flex">
        Volver al dashboard
      </Link>
    </div>
  );
}
